/*!
 * AJAX Filter for Blog Posts
 * Filters posts by category and search term without page reload.
 * The first post is always displayed and not filtered.
 */
(function($) {
	'use strict';

	var $document = $(document);
	var $filterContainer = $('.blog-filter-container');
	var $categorySelect = $('#category_filter');
	var $searchInput = $('#search_input');

	/**
	 * Make AJAX request to filter posts.
	 */
	function filterPosts(paged, callback) {
		var category = $categorySelect ? $categorySelect.val() : '';
		var search = $searchInput ? $searchInput.val() : '';

		// Show loading state.
		$document.trigger('understrapFilterStart');

		$.post(understrap_ajax_filter.ajax_url, {
			action: 'understrap_filter_posts',
			paged: paged || 1,
			category: category,
			search: search,
			security: understrap_ajax_filter.nonce
		}, function(response) {
			if (response && response.success) {
				// Find the container after the first post for filtered posts.
				// The filters are between first post and remaining posts.
				var $filteredPostsContainer = $filterContainer.nextUntil('.pagination-container');

				// Remove old filtered posts and insert new ones.
				$filteredPostsContainer.find('.hentry, .no-post-content').remove();
				$filteredPostsContainer.prepend(response.data.posts);

				// Update pagination.
				var $paginationContainer = $('.pagination-container');
				if (response.data.pagination) {
					$paginationContainer.html(response.data.pagination);
				} else {
					$paginationContainer.empty();
				}

				// Trigger events for any dependent scripts.
				$document.trigger('understrapFilterComplete', [response.data]);

				if (typeof callback === 'function') {
					callback(response.data);
				}
			}
		}).fail(function(xhr, status, error) {
			$document.trigger('understrapFilterError', [status, error]);
			console.error('AJAX filter error:', status, error);
		});
	}

	/**
	 * Handle category dropdown change.
	 */
	function handleCategoryChange() {
		filterPosts(1);
	}

	/**
	 * Handle search input - debounce for better UX.
	 */
	var searchTimeout;
	function handleSearchChange() {
		clearTimeout(searchTimeout);
		searchTimeout = setTimeout(function() {
			filterPosts(1);
		}, 300); // 300ms debounce
	}

	/**
	 * Handle pagination link clicks.
	 */
	function handlePaginationClick(event) {
		var $link = $(event.target);

		// Only handle actual page links.
		if (!$link.hasClass('page-link')) {
			return;
		}

		event.preventDefault();

		// Extract page number from the link.
		var href = $link.attr('href');
		var pageMatch = href.match(/paged=(\d+)/);
		var paged = pageMatch ? parseInt(pageMatch[1], 10) : 1;

		// Scroll to top of posts.
		$('html, body').animate({ scrollTop: $('#news-wrapper').offset().top - 100 }, 300);

		filterPosts(paged);
	}

	/**
	 * Initialize the AJAX filter.
	 */
	function init() {
		if (!$filterContainer.length) {
			return;
		}

		// Bind events.
		if ($categorySelect.length) {
			$categorySelect.on('change', handleCategoryChange);
		}

		if ($searchInput.length) {
			$searchInput.on('input', handleSearchChange);
		}

		// Delegated event for pagination (works with dynamically replaced content).
		$('.pagination-container').on('click', '.page-link', handlePaginationClick);

		// Trigger initial filter if there are saved filter values from URL or session.
		// This allows bookmarking/filter persistence if implemented later.
	}

	// Initialize when DOM is ready.
	$(init);

	// Expose for external use.
	window.UnderstrapAjaxFilter = {
		filter: filterPosts
	};

})(jQuery);
